<template>
    <section class="userSteps vh-100 overflow-auto">
          <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row">
            <div class="col-12">
                <router-link class="d-flex align-items-center backBtn medium" to="/connect-account"> <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('mannual_proof.text1')}} </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('mannual_proof.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('become_leader.text1')}}<span class="bgTitle">{{$t('become_leader.text2')}}</span></h3>
                    <p class="mb-0">{{$t('become_leader.text3')}}</p>
                </div>
            </div>
            
            <div class="col-12 col-md-6">
                <Form class="personalDetails" @submit="submit">
                    <float-label class="form-group">
                         <Field type="text" v-model="title" class="form-control largeInput me-2" name="title" :placeholder="$t('become_leader.text4')" :rules="isTitleRequired" />
                          <ErrorMessage class="text-danger d-block f-12 mt-1" name="title" />
                    </float-label>
                    <div class="form-group ConnectBroker">
                        <div class="position-relative iconInput">
                            <Field as="textarea" v-model="description" class="form-control largeInput textarea me-2 f-15 pe-2" name="description" placeholder="" :rules="isdescriptionRequired" />
                            <ErrorMessage class="text-danger d-block f-12 mt-1" name="description" />
                            <div class="position-absolute countText"><span class="f-13">{{description.length}}</span> {{$t('become_leader.text5')}} <span class="f-13">{{$t('become_leader.text6')}}</span></div>
                        </div>
                    </div>
                    <div class="col-12 mb-4" v-if="importHistoryStatus()">
                        <label class="customCheckBox mb-3">
                            <span class="d-flex align-items-center">{{$t('become_leader.text13')}}<i class="small fa fa-info-circle" aria-hidden="true"></i></span>
                            <input type="checkbox" class="form-control" name="importHistory" v-model="importHistory" true-value="true" false-value="false" />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="buttonElement mb-3">
                        <button type="submit" class="grd_btn full_size"> {{$t('become_leader.text7')}}</button>
                    </div>
                </Form>
            </div>
            <div class="col-12 col-md-6">
                <div class="accordion accordion-flush ps-lg-5" id="accordionFlushExample">
                    <h4 class="semibold">{{$t('become_leader.text8')}}</h4>
                    <div class="accordion-item" v-for="value,key,index in static_vars.becomeALeaderFAQ" :key="index">
                        <h2 class="accordion-header" :class="(showfaq == index) ? 'show' : ''">
                            <button class="accordion-button" type="button" @click="(showfaq != index) ? showfaq = index : -1">
                                {{key}}
                            </button>
                        </h2>
                        <div  class="accordion-collapse collapse" :class="(showfaq == index) ? 'show' : ''">
                            <div class="accordion-body graycontent">{{value}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { useMainStore } from "@/store";
    import { Form, Field, ErrorMessage } from "vee-validate";
     import FloatLabel from 'vue-float-label/components/FloatLabel'
    export default {
        setup() {
            const store = useMainStore();
            return { store };
        },
        components: { FloatLabel,Form, Field, ErrorMessage },
        data() {
            return {
                showfaq : 0,
                isExpand: "",
                isExpanded: false,
                title: "",
                description: "",
                isLeader: false,
                selectButton:false,
                importHistory : false,
            };
        },
        methods: {
            isTitleRequired(value) {
                if (value && value.trim()) {
                    if (value.length < 8 || value.length > 30) {
                        return this.$t('become_leader.text9');
                    }
                    return true;
                }
                return this.$t('become_leader.text10');
            },
            isdescriptionRequired(value) {
                if (value && value.trim()) {
                    if (value.length < 512 || value.length > 2000) {
                        return this.$t('become_leader.text11');
                    }
                    return true;
                }
                return this.$t('become_leader.text10');
            },
            submit() {
                let data = [];
                if(Object.keys(this.store.userAccoutDetail).length && this.store.userAccoutDetail.accounts && Object.keys(this.store.userAccoutDetail.accounts).length){
                    data = Object.values(this.store.userAccoutDetail.accounts)[Object.values(this.store.userAccoutDetail.accounts).length-1]
                }
                if(Object.keys(data).length){
                    let payload = {
                        strategyName: this.title,
                        strategyDescription: this.description,
                        targetZuluAccountId: data.zuluAccountId,
                    };
                    this.store.accountsBecomeLeader(payload, true,this.importHistory).then(() => {
                        this.store.getUserAccountsList({}, false);
                    });
                }
            },
            importHistoryStatus(){
                if(Object.keys(this.store.userAccoutDetail).length && Object.keys(this.store.userAccoutDetail.accounts).length && this.store.accountConnectSocket?.brokerAccountId){
                    let connectedAccount = Object.values(this.store.userAccoutDetail.accounts).find(i => i.brokerAccountId == this.store.accountConnectSocket.brokerAccountId)
                    if(connectedAccount && connectedAccount.importHistoryStatus === 'AVAILABLE'){
                        return true
                    }
                } return false
            }
        },
    };
</script>
